export default __webpack_public_path__ + "static/media/Odoo_logo.766370b3.svg";